import React, { useEffect } from 'react';
import './Portfolio.css';

const Portfolio = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page when navigating
  }, []);

  const images = [
    '/1.png', '/2.png', '/3.png', '/4.png', '/5.png',
    '/6.png', '/7.png', '/8.png', '/9.png', '/10.png',
    '/11.png', '/12.png', '/13.png', '/14.png', '/15.png',
  ];

  return (
    <div className="portfolio-container">
      {images.map((image, index) => (
        <div key={index} className="portfolio-item">
          <img src={image} alt={`Tattoo ${index + 1}`} />
        </div>
      ))}
    </div>
  );
};

export default Portfolio;
